<app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>
<div class="container">
    <div class="d-flex justify-content-end mt-4">
        <div class="d-flex col-md-3 mt-2 me-5">
            <label class="col-md-8 mt-1 me-3">Registros por página</label>
            <select class="form-select col-xs-2" aria-label="Default select example" [(ngModel)]="tamanoPagina">
                <option disabled value="0" class="color-gris">Escoja el aplicativo</option>
                <option value=10>{{ 10 }}</option>
                <option value=20>{{ 20 }}</option>
                <option value=50>{{ 50 }}</option>
                <option value=100>{{ 100 }}</option>
                <option value=200>{{ 200 }}</option>
            </select>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <div class="col-lg-12 mt-4">
            <table class="table mt-2"  aria-describedby="mydesc">
                <thead class="fondo-gris">
                    <tr>
                        <th scope="col" class="text-center">ID Transacción</th>
                        <th scope="col" class="text-center">Fecha y hora</th>
                        <th scope="col" class="text-center">Usuario</th>
                        <th scope="col" class="text-center">Operación</th>
                        <th scope="col" class="text-center">Entidad Afectada</th>
                        <th scope="col" class="text-center">Rol</th>
                        <th scope="col" class="text-center">Estación</th>
                        <th scope="col" class="text-center">Servidor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let accion of acciones | paginate: { itemsPerPage: tamanoPagina, currentPage: pagina }">
                        <td class="text-center">TR-{{ ("000000" + accion.id).slice(-6) }}</td>
                        <td class="text-center">{{ accion.fechaCreacion }}</td>
                        <td class="text-center">{{ accion.usuarioModificador}}</td>
                        <td class="text-center">{{ accion.accion }}</td>
                        <td class="text-center">{{ accion.usuario!=null ?  accion.usuario : accion.aplicativo}}</td>
                        <td class="text-center">{{ accion.rol }}</td>
                      <td class="text-center">{{ accion.entidad ?? "" }}</td>
                      <td class="text-center">{{ accion.servidor ?? "" }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-2">
                <pagination-controls class="clase-paginador" (pageChange)="pagina = $event" previousLabel="Anterior"
                    nextLabel="Siguiente"></pagination-controls>
            </div>
        </div>
    </div>
</div>
